import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import boardContent from "../asset/3content.png";
import { Eldery3Table } from "../components/elderyContent/Eldery3Table";
import eld_diagram from "../asset/eld_diagram1.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: 2500,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    fontFamily: "Roboto",
    width: "100%",
    flexGrow: 1,
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: "100%",
      borderTop: "none",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      display: "none",
    },
  },
  container2: {
    marginTop: 100,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      display: "none",
    },
  },
  container3: {
    marginTop: 40,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      flexDirection: "column",
      display: "none",
    },
  },
  container4: {
    marginTop: 25,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      display: "none",
    },
  },
  container5: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 70,
    justifyContent: "center",
    height: "800px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: 30,
      display: "none",
    },
  },

  container6: {
    marginTop: 30,
    maxWidth: 824,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  container7: {
    maxWidth: 824,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    marginBottom: 45,
    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  container8: {
    maxWidth: 824,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    marginBottom: 45,
    top: -40,
    position: "relative",
    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  container9: {
    top: -130,
    position: "relative",
    marginTop: 40,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      top: 0,
    },
  },

  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 50,
      justifyContent: "flex-start",
    },
  },
  slideBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  table: {
    "&>table": {
      border: "1px solid black",
      borderCollapse: "collapse",
    },
    "&>th, td": {
      border: "1px solid black",
    },
    width: "856px",
    fontSize: "12px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "15px 10px",
    },
  },
  squareVector: {
    position: "relative",
    backgroundColor: "#E6EAF9",
    borderRadius: "5px",
    width: 122,
    height: 146,
    marginRight: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    "&:after": {
      content: '""',
      position: "absolute",
      top: "30%",
      right: -25,
      width: 0,
      height: 0,
      border: "25px solid transparent",
      borderLeftColor: "#E6EAF9",
      borderRight: 0,
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: 20,
      width: 100,
      height: 120,
      "&:after": {
        content: '""',
        position: "absolute",
        top: "36%",
        right: -17,
        width: 0,
        height: 0,
        border: "18px solid transparent",
        borderLeftColor: "#E6EAF9",
        borderRight: 0,
      },
    },
  },
  vectorInPink: {
    position: "absolute",
    top: 0,
    left: 0,
    background: "#E5AAE7",
    width: 34,
    height: 34,
    borderRadius: "5px 0px",
    color: "#fff",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginBottom: 10,
    },
  },
  underline: {
    width: "140px",
    color: "#000",
    justifyContent: "center",
    marginTop: 1,
    marginBottom: 2,
  },
  arrowBox1: {
    fontSize: "16px",
    fontWeight: 700,
    position: "relative",
    left: "-195px",
    textDecoration: "underline",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginBottom: 10,
      left: "80px",
      top: "-6px",
    },
  },
  arrowBox2: {
    fontSize: "16px",
    fontWeight: 700,
    position: "relative",
    left: "70px",
    textDecoration: "underline",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      left: "-190px",
      top: "190px",
    },
  },
  arrowBox3: {
    fontSize: "16px",
    fontWeight: 700,
    position: "relative",
    left: "-10px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  contentImage: {
    position: "relative",
    width: 858,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  contentImageM: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  contentImageTitle: {
    position: "relative",
    fontWeight: 700,
    left: -260,
    top: 345,
    zIndex: 5,
    display: "block",
    fontSize: "24px",
    textAlign: "center",
    color: "#fff",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: "18px",
      top: 165,
      left: 38,
    },
  },
  contentImageTable1: {
    position: "relative",
    left: 422,
    top: -561,
    width: 355,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      top: -430,
      left: 52,
      width: 313,
      position: "relative",
    },
  },
  contentImageTable2: {
    position: "relative",
    left: 450,
    top: -424,
    width: 355,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      top: -347,
      left: 61,
      width: 280,
      position: "relative",
    },
  },
  contentImageTable3: {
    position: "relative",
    left: 425,
    top: -290,
    width: 375,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      top: -270,
      left: 48,
      width: 328,
      position: "relative",
    },
  },
  contentImageTd1: {
    color: "#9ed3e3",
    paddingRight: 50,
    fontWeight: 700,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: "10px",
      paddingRight: 0,
      fontWight: 300,
    },
  },
  contentImageTd11: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: 700,
    borderBottom: "1px solid black",
    paddingBottom: 10,
    width: 222,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontWight: 300,
    },
  },
  contentImageTd2: {
    color: "#dad2f3",
    paddingRight: 55,
    fontWeight: 700,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      paddingRight: 40,
    },
  },
  contentImageTd21: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: 700,
    borderBottom: "1px solid black",
    paddingBottom: 10,
  },
  contentImageTd3: {
    color: "#84e4df",
    paddingRight: 42,
    fontWeight: 700,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 12,
      paddingRight: 15,
    },
  },

  contentImageTd31: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "25px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 12,
    },
  },

  mobileTableBox: {
    maxWidth: 824,
    width: "100%",
    margin: "0px",
    height: "auto",
    wordBreak: "keep-all",
    marginTop: 50,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mobileTable: {
    margin: "15px 10px",
    borderCollapse: "collapse",
  },
  pinkCircle: {
    borderRadius: "100%",
    background: "#EB5FE5",
    width: 156,
    height: 156,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
    fontWeight: 700,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: 120,
      height: 120,
    },
  },
  elderContent: {
    width: 854,
    wordBreak: "keep-all",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "15px 10px",
    },
  },
  textBox1: {
    width: 852,
    alignSelf: "center",
    position: "relative",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: 20,
      marginBottom: 20,
      textAlign: "justify",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 20,
    },
  },
}));

export const ElderyContentPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      {/* Body start */}
      <div className={classes.body}>
        <div className={classes.container}>
          <div className={classes.textBox1}>
            <img
              src={halfCircleBlue}
              alt="blueHalfCircle"
              className={classes.halfCircleBlue}
            />
            <Typography variant="H3" className={classes.top_text}>
              사업내용
            </Typography>
          </div>
        </div>

        <div className={classes.container}>
          <div style={{ width: "856px", marginBottom: "100px" }}>
            <span>
              중국의 만학교육과 연계하여 중국 간호학과 교수, 임상실무 전문가의
              중국 재택 양로 제도, 양로 보험제도, 양로 발전 방향, 양로 협력
              사업에 대한 이론 교육과정을 진행하였습니다.
            </span>
          </div>
          <div>
            <img src={eld_diagram} alt="eld_diagram"></img>
          </div>
        </div>
        {/* 모바일용> 교육설명 테이블 */}

        <div className={classes.mobileTableBox}>
          <div style={{ marginBottom: 20 }}>
            <img
              src={halfCircleBlue}
              alt="blueHalfCircle"
              className={classes.halfCircleBlue}
            />
            <Typography variant="H3" className={classes.top_text}>
              사업내용
            </Typography>
          </div>
          <div style={{ marginBottom: 20, padding: "0px 10px" }}>
            <span>
              중국의 만학교육과 연계하여 중국 간호학과 교수, 임상실무 전문가의
              중국 재택 양로 제도, 양로 보험제도, 양로 발전 방향, 양로 협력
              사업에 대한 이론 교육과정을 진행하였습니다.
            </span>
          </div>
          <div style={{ padding: 10 }}>
            <img
              src={eld_diagram}
              alt="m_eld_diagram"
              style={{ width: "100%" }}
            ></img>
          </div>
        </div>

        <div className={classes.container2}>
          {/* 1번 화살표 박스 */}
          <div className={classes.arrowBox1} style={{}}>
            <span style={{}}>Cumulated Knowledge</span>
            <svg
              style={{ top: 38, left: -82, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 35.3536C3.84171 35.5488 4.15829 35.5488 4.35355 35.3536L7.53554 32.1716C7.7308 31.9763 7.7308 31.6597 7.53554 31.4645C7.34027 31.2692 7.02369 31.2692 6.82843 31.4645L4 34.2929L1.17157 31.4645C0.976312 31.2692 0.65973 31.2692 0.464467 31.4645C0.269205 31.6597 0.269205 31.9763 0.464468 32.1716L3.64645 35.3536ZM3.5 2.18557e-08L3.5 35L4.5 35L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="black"
              />
            </svg>
          </div>

          {/* 2번 화살표 박스 */}
          <div className={classes.arrowBox2}>
            <span>Visionary Awareness</span>
            <svg
              style={{ top: 38, left: -82, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 35.3536C3.84171 35.5488 4.15829 35.5488 4.35355 35.3536L7.53554 32.1716C7.7308 31.9763 7.7308 31.6597 7.53554 31.4645C7.34027 31.2692 7.02369 31.2692 6.82843 31.4645L4 34.2929L1.17157 31.4645C0.976312 31.2692 0.65973 31.2692 0.464467 31.4645C0.269205 31.6597 0.269205 31.9763 0.464468 32.1716L3.64645 35.3536ZM3.5 2.18557e-08L3.5 35L4.5 35L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="black"
              />
            </svg>
          </div>
        </div>

        <div className={classes.container3}>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              1차
            </div>
            <span>
              노인 돌봄
              <br />
              역량 교육
            </span>
            <div></div>
          </div>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              2차
            </div>
            <span>
              재택 양로
              <br />
              관리 시스템
              <br />
              교육
            </span>
          </div>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              3차
            </div>
            <span>
              노인 돌봄
              <br />
              역량 교육
            </span>
          </div>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              4차
            </div>
            <span>
              노인 돌봄
              <br />
              역량 교육
            </span>
          </div>

          {/* 분홍색 원 */}

          <div
            style={{
              borderRadius: "100%",
              background: "#EB5FE5",
              width: 156,
              height: 156,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              color: "#fff",
              fontWeight: 700,
            }}
          >
            고령친화산업
            <br />
            전문인력 양성
          </div>
        </div>

        {/* 3번 화살표 박스 */}
        <div className={classes.container4}>
          <div className={classes.arrowBox3} style={{}}>
            <span style={{ textDecoration: "overline" }}>
              Visionary Awareness
            </span>
            <svg
              style={{ top: -18, left: -78, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.35355 0.646446C4.15829 0.451183 3.84171 0.451183 3.64645 0.646446L0.464465 3.82843C0.269203 4.02369 0.269203 4.34027 0.464465 4.53553C0.659727 4.7308 0.976309 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.73079 4.34027 7.73079 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 36L4.5 1L3.5 1L3.5 36L4.5 36Z"
                fill="black"
              />
            </svg>
          </div>
        </div>

        {/* 모바일 벡터 1~4차 커리큘럼 */}
        <div className={classes.container6}>
          {/* 1번 화살표 박스 */}
          <div className={classes.arrowBox1} style={{}}>
            <span style={{}}>Cumulated Knowledge</span>
            <svg
              style={{ top: 38, left: -82, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 35.3536C3.84171 35.5488 4.15829 35.5488 4.35355 35.3536L7.53554 32.1716C7.7308 31.9763 7.7308 31.6597 7.53554 31.4645C7.34027 31.2692 7.02369 31.2692 6.82843 31.4645L4 34.2929L1.17157 31.4645C0.976312 31.2692 0.65973 31.2692 0.464467 31.4645C0.269205 31.6597 0.269205 31.9763 0.464468 32.1716L3.64645 35.3536ZM3.5 2.18557e-08L3.5 35L4.5 35L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="black"
              />
            </svg>
          </div>

          {/* 2번 화살표 박스 */}
          <div className={classes.arrowBox2}>
            <span>Visionary Awareness</span>
            <svg
              style={{ top: 38, left: -82, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 35.3536C3.84171 35.5488 4.15829 35.5488 4.35355 35.3536L7.53554 32.1716C7.7308 31.9763 7.7308 31.6597 7.53554 31.4645C7.34027 31.2692 7.02369 31.2692 6.82843 31.4645L4 34.2929L1.17157 31.4645C0.976312 31.2692 0.65973 31.2692 0.464467 31.4645C0.269205 31.6597 0.269205 31.9763 0.464468 32.1716L3.64645 35.3536ZM3.5 2.18557e-08L3.5 35L4.5 35L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="black"
              />
            </svg>
          </div>
        </div>

        <div className={classes.container7}>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              1차
            </div>
            <span>
              노인 돌봄
              <br />
              역량 교육
            </span>
            <div></div>
          </div>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              2차
            </div>
            <span>
              재택 양로
              <br />
              관리 시스템
              <br />
              교육
            </span>
          </div>
        </div>
        <div className={classes.container7}>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              3차
            </div>
            <span>
              내용
              <br />
              필요
            </span>
          </div>
          <div className={classes.squareVector}>
            <div className={classes.vectorInPink} style={{}}>
              4차
            </div>
            <span>
              내용
              <br />
              필요
            </span>
          </div>

          {/* 분홍색 원 */}

          <div className={classes.pinkCircle}>
            고령친화산업
            <br />
            전문인력 양성
          </div>
        </div>

        {/* 3번 화살표 박스 */}
        <div className={classes.container8}>
          <div className={classes.arrowBox3}>
            <span style={{ textDecoration: "overline" }}>
              Visionary Awareness
            </span>
            <svg
              style={{ top: -18, left: -78, position: "relative" }}
              width="8"
              height="36"
              viewBox="0 0 8 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.35355 0.646446C4.15829 0.451183 3.84171 0.451183 3.64645 0.646446L0.464465 3.82843C0.269203 4.02369 0.269203 4.34027 0.464465 4.53553C0.659727 4.7308 0.976309 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.73079 4.34027 7.73079 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 36L4.5 1L3.5 1L3.5 36L4.5 36Z"
                fill="black"
              />
            </svg>
          </div>
        </div>

        {/* 3 branch 이미지 */}
        <div className={classes.contentImageM}>
          <Eldery3Table />
        </div>
        <div className={classes.container5}>
          <span className={classes.contentImageTitle}>
            중국 맞춤형 전문
            <br />
            양로 기술
            <br />
            교육 콘텐츠
          </span>

          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              src={boardContent}
              alt="3contents"
              className={classes.contentImage}
            ></img>

            {/* Knowledge 테이블 */}

            <table className={classes.contentImageTable1}>
              <tr>
                <td rowSpan={2} className={classes.contentImageTd1}>
                  Knowledge
                </td>
                <td className={classes.contentImageTd11}>
                  노인의 이해 요양 기초 지식
                  <br />
                  노인대상자의 건강문제
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    paddingTop: 10,
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: 700,
                  }}
                >
                  중국 노인대상자의 주요 건강문제
                </td>
              </tr>
            </table>

            {/* Skill 테이블 */}
            <table
              className={classes.contentImageTable2}
              style={
                {
                  // width: 330,
                  // position: "relative",
                  // left: 450,
                  // top: -430
                }
              }
            >
              <tr>
                <td rowSpan={2} className={classes.contentImageTd2}>
                  Skill
                </td>
                <td className={classes.contentImageTd21}>
                  상급 전문 요양 기술
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    paddingTop: 10,
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: 700,
                  }}
                >
                  중국 노인 요양 기술 적용 사례
                  <br />
                  중국 요양 기술 관리 지침
                </td>
              </tr>
            </table>

            {/* Awareness 테이블 */}
            <table
              className={classes.contentImageTable3}
              style={
                {
                  // width: 375,
                }
              }
            >
              <tr>
                <td rowSpan={2} className={classes.contentImageTd3}>
                  Awareness
                </td>
                <td className={classes.contentImageTd31}>
                  중국 노인 대상자 이해 중국 노인 인권
                  <br />
                  중국 주거환경 중국 노인 임종 돌봄
                  <br />
                  중국 노인과의 의사소통 직업윤리
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className={classes.container9}>
          <div className={classes.elderContent}>
            <Typography variant="elderContent">
              중국 현지화 교육의 일환으로 중국의 만학교육과 실무자 케이스
              컨퍼런스를 실시간으로 진행였습니다.
              <br />
              총 치매, 와상, 욕창, 여러 가지 튜브를 가지고 있는 재가 노인
              대상자의 건강문제에 대해 한국의 사례와 중국의 사례를 교환하는
              방식으로 진행하였고 효율적인 케어방안에 대해 토론의 장을
              마련하였습니다.
              <br />
              특히 한국의 사례는 애니메이션 형태로 제작되어 중국의 만학교육
              실무담당자 등의 이해 증진을 도모하였습니다.
              <br />
              케이스 컨퍼런스로 협업을 진행한 중국의 간호학과 교수님은 “한국의
              재가 노인 케이의 우수성에 대해 깊은 인상을 받았으며 지속적으로
              교류하고 싶다”는 긍정적인 피드백을 받았습니다.
              <br />
              휴먼브릿지는 재가 요양서비스의 노하우와 전문적인 교육 경험, 중국에
              대한 이해도를 바탕으로 중국 및 세계의 재가요양 및 간호 교육
              콘텐츠를 지속적으로 제공할 예정입니다.
              <br />
            </Typography>
          </div>
        </div>
      </div>

      {/* Footer start*/}
      <div>
        <Footer />
      </div>
      {/* Footer end */}
      {/* Mobile Footer start */}
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
      {/* Mobile Footer end */}
    </div>
  );
};
